import { render } from "./TemporaryMain.vue?vue&type=template&id=340a9957&scoped=true"
import script from "./TemporaryMain.vue?vue&type=script&lang=js"
export * from "./TemporaryMain.vue?vue&type=script&lang=js"

import "./TemporaryMain.vue?vue&type=style&index=0&id=340a9957&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340a9957"]])

export default __exports__